export default __webpack_public_path__ + "static/SRF 0115PW - Fiche de spécifications et données techniques-26f5461fe20b947d53e5badb1778ea12.pdf";